import React from 'react';
import LoadingSkapa, { LoadingBall } from '@ingka/loading';
import { useTranslation } from 'react-i18next';
import { Layout } from '@pcmp/react-coworker-components';

const { Container } = Layout;

export const LoadingState = () => {
  const { t } = useTranslation();

  return (
    <LoadingSkapa data-testid="loading" text={t('label.loading')}>
      <LoadingBall color="emphasised" size="large" />
    </LoadingSkapa>
  );
};

export const LoadingFullScreen = () => (
  <Container className="h-screen flex align-middle justify-center">
    <LoadingState />
  </Container>
);
